import React from 'react';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Oficiales albañiles que quieren independizarse.', 'Ayudantes avanzados que ya saben el oficio pero no saben cobrar.', 'Pequeños contratistas que sienten que la plata se les escapa entre los dedos.', 'Trabajadores que quieren dejar de depender de un patrón.'];
  const notForWho = ['Gente que busca plata fácil sin trabajar (la obra es dura).', 'Quienes no están dispuestos a cambiar su forma de organizarse.', 'Arquitectos que buscan teoría académica (esto es práctica de calle).'];
  return <section className="py-20 px-4 bg-cement" data-id="element-1">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2">
        {/* For Who */}
        <div className="bg-white border-2 border-charcoal shadow-hard p-8 rounded-sm" data-id="element-3">
          <h3 className="font-heading font-bold text-3xl text-charcoal uppercase mb-6 flex items-center gap-3" data-id="element-4">
            <div className="bg-whatsapp p-1 rounded-sm" data-id="element-5">
              <Check className="h-6 w-6 text-white" strokeWidth={4} data-id="element-6" />
            </div>
            Esto ES para vos si:
          </h3>
          <ul className="space-y-4" data-id="element-7">
            {forWho.map((item, index) => <li key={index} className="flex items-start gap-3 font-body text-lg text-stone-700" data-id="element-8">
                <Check className="h-6 w-6 text-whatsapp shrink-0 mt-0.5" strokeWidth={3} data-id="element-9" />
                <span data-id="element-10">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For Who */}
        <div className="bg-stone-200 border-2 border-stone-400 p-8 rounded-sm" data-id="element-11">
          <h3 className="font-heading font-bold text-3xl text-stone-500 uppercase mb-6 flex items-center gap-3" data-id="element-12">
            <div className="bg-brick p-1 rounded-sm" data-id="element-13">
              <X className="h-6 w-6 text-white" strokeWidth={4} data-id="element-14" />
            </div>
            Esto NO es para vos si:
          </h3>
          <ul className="space-y-4" data-id="element-15">
            {notForWho.map((item, index) => <li key={index} className="flex items-start gap-3 font-body text-lg text-stone-600" data-id="element-16">
                <X className="h-6 w-6 text-brick shrink-0 mt-0.5" strokeWidth={3} data-id="element-17" />
                <span data-id="element-18">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}